import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { signIn, RestError } from '../rest/authClient';
import styles from '../styles/pages/SignIn.module.css';
import base from '../styles/Base.module.css';
import SignInTO from '../model/SignInTO';
import { useUserUpdateContext } from '../contexts/UserContext';
import DefaultPage from './DefaultPage';
import { useErrorUpdateContext } from '@ax2/common/contexts/ErrorContext';
import { ActionButton } from '@ax2/common/components/ActionButton';
import { getErrorMessage } from '@ax2/common/helpers/error';
import * as Yup from 'yup';
import TrialExpiredModal from 'components/TrialExpiredModal';
import { requiredSchema } from '../helpers/validations';

const signInSchema = Yup.object().shape({
  email: requiredSchema('Email is required'),
  password: requiredSchema('Password is required'),
});

const SignIn: React.FC<RouteComponentProps> = ({ history }) => {
  const updateUser = useUserUpdateContext();
  const updateError = useErrorUpdateContext();
  const [isTrialExpired, setTrialExpired] = useState(false);

  return (
    <DefaultPage header={{ title: 'Sign In' }}>
      {isTrialExpired && (
        <TrialExpiredModal
          onClose={() => {
            setTrialExpired(false);
          }}
        />
      )}
      <div className={base.actionBox}>
        <p className={base.sectionText}>
          Please sign in below with your existing account credentials.
        </p>
        <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={signInSchema}
          onSubmit={(values, { setSubmitting }) => {
            signIn(new SignInTO(values.email, values.password))
              .then(authResponse => {
                setSubmitting(false);
                updateUser(authResponse);
                history.push('/dashboard');
              })
              .catch((err: RestError) => {
                setSubmitting(false);
                if (err.reason === 'AccountExpired') {
                  setTrialExpired(true);
                } else {
                  updateError({
                    text: getErrorMessage(err),
                  });
                }
              });
          }}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form className={styles.userForm}>
              <label className={styles.userFormLabel}>Email</label>
              <Field
                autoComplete="new-password"
                type="email"
                name="email"
                className={styles.userInput}
              />
              <ErrorMessage
                name="email"
                component="div"
                className={styles.userFormError}
              />
              <label className={styles.userFormLabel}>Password</label>
              <Field
                autoComplete="new-password"
                type="password"
                name="password"
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onKeyPress={(e: any) => {
                  e.key === 'Enter' && !isSubmitting && handleSubmit();
                }}
                className={styles.userInput}
              />
              <ErrorMessage
                name="password"
                component="div"
                className={styles.userFormError}
              />
              <div className={styles.userActionsContainer}>
                <button
                  type="button"
                  className={base.linkButton}
                  onClick={() => history.push('/signUp')}
                >
                  Sign Up
                </button>
                <button
                  type="button"
                  className={base.linkButton}
                  onClick={() => history.push('/forgotPassword')}
                >
                  Forgot password?
                </button>
              </div>
              <ActionButton
                onClick={() => !isSubmitting && handleSubmit()}
                type="primary"
                loading={isSubmitting}
                text="Log In"
              />
            </Form>
          )}
        </Formik>
      </div>
    </DefaultPage>
  );
};

export default withRouter(SignIn);
